// extracted by mini-css-extract-plugin
export default {"page-title":"InnerTitleSection_page-title__KnBGI","heading":"InnerTitleSection_heading__ZpBkV"};